if (!customElements.get("popup-buy-modal")) {
  customElements.define(
    "popup-buy-modal",
    class PopupBuyModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.goBackButton = this.querySelector(".step-heading__go-back");

        this.goBackButton.addEventListener("click", () => this.showFirstStepElementsAndHideSecondStep());

        this.addEventListener("product-info:loaded", ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";
        this.querySelector(".popup-buy__modal-review-block").style.display = "none";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, "text/html");
            const productElement = responseHTML.querySelector("product-info");

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            this.modalContent.querySelector(".popup-buy_next-step-button").addEventListener("click", () => {
              this.handleSecondStepTrigger();
            });
            const formSubmitButton = this.modalContent.querySelector(".product-form__submit");
            if (formSubmitButton)
              formSubmitButton.addEventListener("click", () => {
                this.hide(true);
              });

            // Ajout pour redemander au cart drawer de Handle la soumission de formulaire du quick-add, sinon ca va sur /cart
            if (document.querySelector("deployer-cart-drawer")) document.querySelector("deployer-cart-drawer").setProductFormCompatibility();

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith("color-") || classApplied === "gradient") this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute("data-update-url", "false");
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector("pickup-availability");
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector("product-modal");
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll("modal-dialog");
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());

        const productMediaWrapper = productElement.querySelector(".product__media-wrapper");
        if (productMediaWrapper) productMediaWrapper.remove();

        const jdmgeWidget = productElement.querySelector(".jdgm-widget");
        if (jdmgeWidget) jdmgeWidget.remove();

        const mainTitle = productElement.querySelector("h1");
        if (mainTitle) mainTitle.remove();

        const textAndIcons = productElement.querySelector(".text-and-icon_container");
        if (textAndIcons) textAndIcons.remove();

        const deployerVariantBuilderTitle = productElement.querySelector(".deployer-variant-builder_title-container");
        if (deployerVariantBuilderTitle) deployerVariantBuilderTitle.remove();

        const modalOpener = productElement.querySelector("modal-opener");
        if (modalOpener) modalOpener.remove();

        const productAccordions = productElement.querySelectorAll(".product__accordion");
        if (productAccordions) productAccordions.forEach((accordion) => accordion.remove());

        const textAndIcon = productElement.querySelector(".text-and-icon_container");
        if (textAndIcon) textAndIcon.remove();

        const stickyAtcButton = productElement.querySelector("sticky-atc-button");
        if (stickyAtcButton) stickyAtcButton.remove();

        const subscribeLabel = productElement.querySelector(".subscriptions-widget-title");
        if (subscribeLabel) subscribeLabel.remove();

        const oneTimePurchaseInput = productElement.querySelector("#one-time-purchase");
        if (oneTimePurchaseInput) oneTimePurchaseInput.id = "one-time-purchase-popup";

        const oneTimePurchaseLabel = productElement.querySelector('label[for="one-time-purchase"]');
        if (oneTimePurchaseLabel) oneTimePurchaseLabel.setAttribute("for", "one-time-purchase-popup");

        const subscriptionPurchaseInput = productElement.querySelector("#subscription-purchase");
        if (subscriptionPurchaseInput) subscriptionPurchaseInput.id = "subscription-purchase-popup";

        const subscriptionPurchaseLabel = productElement.querySelector('label[for="subscription-purchase"]');
        if (subscriptionPurchaseLabel) subscriptionPurchaseLabel.setAttribute("for", "subscription-purchase-popup");

        const triggerTextTop = productElement.querySelector(".popup-buy__trigger-text-top");
        if (triggerTextTop) triggerTextTop.style.display = "none";

        this.hideSecondStepElements(productElement);
        this.addSecondStepTrigger(productElement);
      }

      hideSecondStepElements(productElement) {
        const productForm = productElement.querySelector("product-form");
        if (productForm) productForm.style.display = "none";
        const deployerVariantBuilder = productElement.querySelector(".product deployer-variant-builder");
        if (deployerVariantBuilder) deployerVariantBuilder.style.display = "block";
        const subscribeWidget = productElement.querySelector(".product .subscriptions-widget-container");
        if (subscribeWidget) subscribeWidget.style.display = "none";
        const deliveryEstimation = productElement.querySelector("delivery-estimation");
        if (deliveryEstimation) deliveryEstimation.style.display = "none";
        const textAndIcon = productElement.querySelectorAll(".text-and-icon_container");
        if (textAndIcon) textAndIcon.forEach((element) => (element.style.display = "none"));
        const secondStepHeading = this.modalContent.closest('.quick-add-modal__content-info').querySelector(".step-heading-2");
        if (secondStepHeading) secondStepHeading.style.display = "none";
        const stepHeadingFirst = this.modalContent.closest('.quick-add-modal__content-info').querySelector(".step-heading-1");
        if (stepHeadingFirst) stepHeadingFirst.style.display = "flex";
      }

      showFirstStepElementsAndHideSecondStep() {
        const deployerVariantBuilder = this.modalContent.querySelector(".product  deployer-variant-builder");
        if (deployerVariantBuilder) deployerVariantBuilder.style.display = "block";
        const nextStepButton = this.modalContent.querySelector(".popup-buy_next-step-button");
        if (nextStepButton) nextStepButton.style.display = "flex";
        const stepHeadingFirst = this.modalContent.closest('.quick-add-modal__content-info').querySelector(".step-heading-1");
        if (stepHeadingFirst) stepHeadingFirst.style.display = "flex";
        const stepHeadingSecond = this.modalContent.closest('.quick-add-modal__content-info').querySelector(".step-heading-2");
        if (stepHeadingSecond) stepHeadingSecond.style.display = "none";
        const reviewBlock = this.querySelector(".popup-buy__modal-review-block");
        if (reviewBlock) reviewBlock.style.display = "none";

        const productForm = this.modalContent.querySelector("product-form");
        if (productForm) productForm.style.display = "none";
        const subscribeWidget = this.modalContent.querySelector(".product .subscriptions-widget-container");
        if (subscribeWidget) subscribeWidget.style.display = "none";
        const deliveryEstimation = this.modalContent.querySelector("delivery-estimation");
        if (deliveryEstimation) deliveryEstimation.style.display = "none";
        const textAndIcon = this.modalContent.querySelectorAll(".text-and-icon_container");
        if (textAndIcon) textAndIcon.forEach((element) => (element.style.display = "none"));
      }

      hideFirstStepElements() {
        const deployerVariantBuilder = this.modalContent.querySelector(".product deployer-variant-builder");
        if (deployerVariantBuilder) deployerVariantBuilder.style.display = "none";
        const nextStepButton = this.modalContent.querySelector(".popup-buy_next-step-button");
        if (nextStepButton) nextStepButton.style.display = "none";
        const stepHeadingFirst = this.modalContent.closest('.quick-add-modal__content-info').querySelector(".step-heading-1");
        if (stepHeadingFirst) stepHeadingFirst.style.display = "none";
        const stepHeadingSecond = this.modalContent.closest('.quick-add-modal__content-info').querySelector(".step-heading-2");
        if (stepHeadingSecond) stepHeadingSecond.style.display = "flex";
        const reviewBlock = this.querySelector(".popup-buy__modal-review-block");
        if (reviewBlock) reviewBlock.style.display = "block";
      }

      addSecondStepTrigger(productElement) {
        const button = document.createElement("button");
        button.classList.add("button", "button--primary", "button--full-width", "popup-buy_next-step-button");
        const priceContainer = `<div class="price">
                                  <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Prix habituel</span>
                                        <span class="price-item price-item--regular">${formatPrice(0)}</span></div>
                                    <div class="price__sale">
                                        <span class="visually-hidden visually-hidden--inline">Prix habituel</span>
                                        <span>
                                          <s class="price-item price-item--regular">
                                          </s>
                                        </span><span class="visually-hidden visually-hidden--inline">Prix promotionnel</span>
                                      <span class="price-item price-item--sale price-item--last">
                                        9,90€
                                      </span>
                                    </div>
                                    <small class="unit-price caption hidden">
                                      <span class="visually-hidden">Prix unitaire</span>
                                      <span class="price-item price-item--last">
                                        <span></span>
                                        <span aria-hidden="true">/</span>
                                        <span class="visually-hidden">&nbsp;par&nbsp;</span>
                                        <span>
                                        </span>
                                      </span>
                                    </small>
                                  </div>
                                </div>
                              `;
        button.innerHTML = `<span class="product-form__submit__text">VALIDER MON CHOIX</span><span class="product-form__submit__separator"> | </span><span class="product-form__submit__price-container">${priceContainer}</span>`;
        productElement.querySelector(".product__info-container").appendChild(button);
      }

      handleSecondStepTrigger() {
        const productForm = this.modalContent.querySelector(".product product-form");
        if (productForm) productForm.style.display = "block";
        const productFormButtons = this.modalContent.querySelector(".product .product-form__buttons");
        if (productFormButtons) productFormButtons.style.display = "block";
        const subscribeWidget = this.modalContent.querySelectorAll(".product .subscriptions-widget-container");
        if (subscribeWidget) subscribeWidget.forEach((widget) => widget.style.display = "block");
        this.hideFirstStepElements();
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
      }
    }
  );
}
